const spacer = document.querySelectorAll('.wd_empty_space')
if ( spacer.length ) {
  spacer.forEach( spacer => {
    wd_empty_space_padding( spacer )
  } )

  window.addEventListener('resize', function () {
    spacer.forEach( spacer => {
      wd_empty_space_padding( spacer )
    } )
  }, true)
}

function wd_empty_space_padding( el ) {
  let mobile_height = el.dataset.heightmobile,
      tablet_height = el.dataset.heighttablet,
      desktop_height = el.dataset.heightdesktop
  if ( window.matchMedia("(max-width: 40em)").matches ) {
    el.style.height = `${mobile_height}px`
  } else if ( window.matchMedia("(min-width: 40.063em) and (max-width: 64em)").matches ) {
    el.style.height = `${tablet_height}px`
  } else if ( window.matchMedia("(min-width: 64.063em)").matches ) {
    el.style.height = `${desktop_height}px`
  }
}